export default __webpack_public_path__ + "static/media/Frozen_01.5749d91f.png";